module.exports = __webpack_public_path__ + "static/img_1415-0e6888b637ab87dfb27d8f0214da806c.webp";